import {etsySettings} from '@coolcolduk/etsy';
import {z} from 'zod';

export const zEtsyTitle = z
  .string()
  .max(etsySettings.listing.title.maxLength)
  .regex(/^[a-zA-Z0-9]/, 'Must start with letter or number') // Must start with letter or number
  .regex(/^[^\s]/, 'Cannot start with space') // Cannot start with space
  .regex(/^[^$^`°]+$/, 'Prohibited characters') // Prohibited characters
  // .regex(/^[^%:&]*[%:&][^%:&]*$/, 'Special chars %:& can only appear once') // Special chars %:& can only appear once
  .refine((val) => {
    const uppercaseWords = val.split(/\s+/).filter((word) => word === word.toUpperCase());
    return uppercaseWords.length <= 3;
  }, 'Title cannot contain more than three words in capital letters');
// .refine((val) => {
//   return val !== val.toUpperCase() && val !== val.toLowerCase();
// }, 'Title must use a mix of upper and lowercase letters');
